import React, { useState } from 'react';
import WizardCard from '../../components/WizardCard/WizardCard';
import TermsAndConditions from './TermsAndConditions';
import classnames from 'classnames';
import withContainer from '../../containers/WithContainer';
import { ContainerNew } from '../../containers/AppContainer';
import { StepNames } from '../../types/stepNames';
import { withRouter, RouteComponentProps } from 'react-router';

interface AgreementProps extends RouteComponentProps {
  appContainer: ContainerNew;
}
const Agreement: React.FunctionComponent<AgreementProps> = props => {
  const [ageChecked, setAgeChecked] = useState(false);
  const [termsChecked, setTermsChecked] = useState(false);
  const [isTermsModalShowing, toggleTermsModal] = useState(false);

  return (
    <WizardCard
      title="One last thing"
      nextLabel="Complete Signup"
      isDisabled={!ageChecked || !termsChecked}
      onNext={() => {
        props.appContainer.updateProvider({
          age_checked: ageChecked,
          terms_checked: termsChecked,
          mobile: props.appContainer.getUserMobile(),
          onboarding_step: props.appContainer.stepsMapping.indexOf(
            StepNames.agreement
          ),
        });
      }}
    >
      <div className="has-margin-top-75">
        <div className="field">
          <input
            className="is-checkradio"
            id="age"
            type="checkbox"
            name="age"
            checked={ageChecked}
            onChange={() => setAgeChecked(!ageChecked)}
          />
          <label htmlFor="age">I am 18 or older</label>
        </div>
      </div>
      <div className="has-margin-top-25">
        <div className="field">
          <input
            className="is-checkradio"
            id="terms"
            type="checkbox"
            name="terms"
            checked={termsChecked}
            onChange={() => setTermsChecked(!termsChecked)}
          />
          <label htmlFor="terms">
            <span>I agree to FLAYR </span>
            <span>Terms and Conditions</span>
          </label>
        </div>
      </div>

      <div className="has-margin-top-15">
        See{' '}
        <span className="has-text-link" onClick={() => toggleTermsModal(true)}>
          Terms and Conditions
        </span>
      </div>

      <div
        className={classnames('modal', { 'is-active': isTermsModalShowing })}
      >
        <div className="modal-background" />
        <div className="modal-card">
          <header className="modal-card-head">
            <p className="modal-card-title">Terms and Conditions</p>
            <button
              className="delete"
              aria-label="close"
              onClick={() => toggleTermsModal(false)}
            />
          </header>
          <section className="modal-card-body">
            <TermsAndConditions />
          </section>
          <footer className="modal-card-foot justify-flex-end">
            <button
              className="button is-link"
              onClick={() => toggleTermsModal(false)}
            >
              Close
            </button>
          </footer>
        </div>
      </div>
    </WizardCard>
  );
};

export default withRouter(withContainer(Agreement));
